import { Link } from 'react-router'
import { DiscordLogo, TwitchLogo, YouTubeLogo } from '@carouselgg/nexus/icon'
import { LogoGradient } from '@carouselgg/nexus/brand'
import { DISCORD_INVITE } from '../constants/links'
import styles from './MarketingFooter.module.css'

const COLUMNS = [
  {
    title: 'Platform',
    links: [
      { to: '/how-it-works', label: 'How it works' },
      { to: '/how-it-works#trust-score', label: 'Trust Score' },
      { to: '/signup', label: 'Create an identity' },
    ],
  },
  {
    title: 'Discover',
    links: [
      { to: '/compete', label: 'Leagues & tournaments' },
      { to: '/orgs', label: 'Organizations' },
      { to: '/orgs?type=university', label: 'University programs' },
    ],
  },
  {
    title: 'For organizers',
    links: [
      { to: '/for/leagues', label: 'Leagues' },
      { to: '/for/clubs', label: 'Clubs & communities' },
      { to: '/for/universities', label: 'Campus programs' },
    ],
  },
  {
    title: 'Company',
    links: [{ to: '/news', label: 'News' }],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy' },
      { to: '/terms', label: 'Terms' },
    ],
  },
]

/**
 * Footer for the public marketing surface. Rendered in normal flow at the end
 * of the page, unlike the fixed AppFooter used inside the product.
 */
export function MarketingFooter() {
  return (
    <footer className={styles.footer}>
      <div className={styles.grid}>
        <div className={styles.brandCol}>
          <Link to="/" className={styles.brand}>
            <img src={LogoGradient} alt="" className={styles.logo} />
            <span className={styles.wordmark}>Carousel</span>
          </Link>
          <p className={styles.blurb}>
            Grassroots infrastructure for organized amateur esports. Verified identity, real
            competition, fair play.
          </p>
          <div className={styles.social}>
            <a
              href={DISCORD_INVITE}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Carousel on Discord"
            >
              <DiscordLogo size={18} />
            </a>
            <a
              href="https://twitch.tv/carouselgg"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Carousel on Twitch"
            >
              <TwitchLogo size={18} />
            </a>
            <a
              href="https://youtube.com/@carouselgg"
              target="_blank"
              rel="noopener noreferrer"
              className={styles.socialLink}
              aria-label="Carousel on YouTube"
            >
              <YouTubeLogo size={18} />
            </a>
          </div>
        </div>

        {COLUMNS.map((column) => (
          <div key={column.title} className={styles.col}>
            <h2 className={styles.colTitle}>{column.title}</h2>
            {column.links.map((link) => (
              <Link key={link.label} to={link.to} className={styles.link}>
                {link.label}
              </Link>
            ))}
          </div>
        ))}
      </div>

      <div className={styles.baseline}>
        <span className={styles.copyright}>
          &copy; {new Date().getFullYear()} Carousel. All rights reserved.
        </span>
        <span className={styles.tagline}>
          Verified identity &middot; Real competition &middot; Fair play
        </span>
      </div>
    </footer>
  )
}
